import React from 'react';
import styled from 'styled-components';
import { ClaroModalCustom, ClaroCardSimple } from "@claropay/shared";
const TitleText = styled.p`
    text-align: center;
    font-family: ${props => props.fontFamily};
    font-size: 20px;
    line-height: 28px;
    margin-top: 0px
    margin-bottom: 16px; 
    color: ${props => props.color};
`;
const SubtitleText = styled.p`
    text-align: center;
    font-family: ${props => props.fontFamily};
    font-size: 16px;
    margin-top: 0px
    margin-bottom: 31.5px;
    color: ${props => props.color};
`;
const ButtonAction = styled.div`
    text-align: center
    display: inline-block;
    background: ${props => props.background ? props.background : "#fff"};
    color: ${props => props.color ? props.color : "#000"};
    padding-top: ${props => props.paddingTop};
    padding-bottom: ${props => props.paddingBottom};
    border: ${props => props.border};
    border-radius: 50px;
    margin: ${props => props.margin ? props.margin : "0px"};
    width: 100%;
    font-family: ${props => props.fontFamily};
    font-size: 16px
`;
function ModalValidationNumberAP(props) {
    const {isContainerTelcel} = props;
    return (
        <ClaroModalCustom isOpen={props.isOpen} backgroundColor={props.backgroundColor}>
            <ClaroCardSimple
                backgroundColor='#fff'
                height='auto'
                borderRadius='6px'
                padding='64px 23.5px 31.5px 23.5px'
                style={{ textAlign: 'center', position: 'relative' }}>
                <img
                    src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAUVBMVEVHcEz/sjX/sTX/rzT/rzT/sTb/sDb/sDX/rzT/sTX/sTb/sTb/sTb/////u0//047/zoH/9eb/xm3/tkP/7tT/2Jr/+vL/4rT/3af/58D/wFuhJ5SzAAAADHRSTlMAv89QPd+PYxvvoK93+126AAACaUlEQVRYw71X6bqjIAyt1wVsDZtrff8HHSLWW29JwDvzTX4iOWYn53ajRVYCpazk7bpUTdF2h7RFU13TflM+QO65GKLYVfrVGS/O9ftBLTLUy3q7q/TTwiH2aVQehNz+3usBPmQwmyEPNqICfe/HCaJiRzSjpY2Qd/yFJtQ3CI03Gkr/y39cB2DFohFfUTdknfj9LmhELQn9BTJkjCOg/TNkyRzzosnXDwg/Iin80RixVnnRn+eLv37KpvT5j9yDUMHxSLbvTjx87cIVgMlnszg7YC8BwODPywOgjjsAsHWQosqhfjNA2asAU/8dx5qsoBUBHFlPexQq34BxA8AxAGhCmFG+Bw1cB8AohGryNUC1oEEACt0not09UPAbAAxxFbrAcI0XK/GTD34KPn8HMIc8tEQVvpqGHhJ2C4L0SWT7lulyn0iJMXQ8AOkg1ll1KzkAbJmOHrMOq1kwSUgBmCSA7TomxP8DYKLmyRmADiLwAA6nkk/jClymexag4gsJ+0UBX0hsKfMAoZSxmWbOSDpCz9BMDTWSkwAmtDM3UPCOg8RA4UYazgwNiZHG+jCNy8RYdz/Genox+czBMdYxD+N1gPH7bRO/MQG3LZF8XGFw6wzJxxWnEpEIRX2x5x3FR0FN1EQaCeRHxoqDD2h0qP5ccbYdZYnGQC3EgyP+7ZoXFuUri2Z81c2qp4VblnVSfaKW7d0LZXn9gV7390h22iZ+3zWSpzxqtFRv9zzlQTceG+kyMdKlN9JVpGis2GmfOdG+We+0r8whnvWLeLpAPNcX8SxELvW9x6jvVfr8N+T7oP/lxv9Z+v8HET2gl84RCcQAAAAASUVORK5CYII='
                    style={{
                        position: 'absolute',
                        top: '-32px',
                        left: '0px',
                        right: '0px',
                        width: '64px',
                        margin: '0px auto'
                    }} />
                <TitleText
                    fontFamily={isContainerTelcel ? 'AMX-Bold' : 'NunitoBold'}
                    color={isContainerTelcel ? '#222222' : '#000000'}>
                    {props.titleText}
                </TitleText>
                <SubtitleText
                 fontFamily={isContainerTelcel ? 'AMX-Regular' : 'Roboto'}
                 color={isContainerTelcel ? '#757575' : '#000000'}>
                    {props.subtitleText}
                </SubtitleText>
                <table cellPadding={'0'} cellSpacing={'0'} style={{ width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ paddingRight: '8px', width: '50%' }}>
                                <ButtonAction
                                    background={props.btn1Background}
                                    color={props.btn1Color}
                                    margin='0px 16px 0px 0px'
                                    onClick={props.btn1Action}
                                    fontFamily={isContainerTelcel ? 'AMX-Bold' : 'RobotoBold'}
                                    paddingTop={isContainerTelcel ? '11px' : '11px'}
                                    paddingBottom={isContainerTelcel ? '10px' : '11px'}
                                    border={isContainerTelcel ? '1px solid #7b1fa2' : '1px solid #000'}>
                                    {props.btn1Text}
                                </ButtonAction>
                            </td>
                            <td align='right' style={{ paddingLeft: '8px', width: '50%' }}>
                                <ButtonAction
                                    background={props.btn2Background}
                                    color={props.btn2Color}
                                    onClick={props.btn2Action}
                                    fontFamily={isContainerTelcel ? 'AMX-Bold' : 'RobotoBold'}
                                    paddingTop={isContainerTelcel ? '11px' : '11px'}
                                    paddingBottom={isContainerTelcel ? '10px' : '11px'}
                                    border={isContainerTelcel ? '1px solid #7b1fa2' : '1px solid #000'}>
                                    {props.btn2Text}
                                </ButtonAction>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ClaroCardSimple>
        </ClaroModalCustom>

    )
}

export default ModalValidationNumberAP;